





























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class RowHeader extends Vue {
  private key: string = ''
  public isAsc: boolean = true // 昇順はtrue, 降順はfalse

  private accoutSort (name: string) {
    if (this.$store.state.accountState.sortAsc) {
      this.$store.commit('accountState/setSortAsc', false)
      this.isAsc = false
    } else {
      this.$store.commit('accountState/setSortAsc', true)
      this.isAsc = true
    }

    let data = {
      order_name: name,
      sort: this.$store.state.accountState.sortAsc
    }

    this.$emit('account-sort', data)
  }
}
